import { LuX } from "react-icons/lu";


export default function SelectionActionBar({
  selectedCount,
  actions,
  onClear,
  selectedLabel = "selected",
}) {
  if (selectedCount === 0) return null;

  const visibleActions = actions.filter(Boolean);

  return (
    <div className="fixed inset-x-0 bottom-4 z-40 flex justify-center px-3">
      <div className="flex max-w-full items-center gap-1 rounded-2xl border border-slate-200 bg-white/95 p-1.5 shadow-[0_10px_30px_rgba(15,23,42,0.14)] backdrop-blur">
        <button
          onClick={onClear}
          title="Clear selection"
          className="flex shrink-0 items-center gap-2 rounded-xl bg-brand-600/10 px-3 py-2 text-[13px] font-medium text-brand-600 transition-colors hover:bg-brand-600/15"
        >
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-gradient text-[11px] font-semibold text-white">
            {selectedCount}
          </span>
          <span className="hidden sm:inline">{selectedLabel}</span>
          <LuX size={14} className="text-brand-600/60" />
        </button>

        <div className="mx-1 h-6 w-px shrink-0 bg-slate-200" />

        <div className="flex items-center gap-1 overflow-x-auto">
          {visibleActions.map(({ key, label, icon: Icon, onClick, danger }) => (
            <button
              key={key}
              onClick={onClick}
              title={label}
              className={`flex shrink-0 items-center gap-1.5 rounded-xl px-3 py-2 text-[13px] font-medium transition-colors ${
                danger
                  ? "text-red-600 hover:bg-red-50"
                  : "text-slate-600 hover:bg-brand-50 hover:text-brand-700"
              }`}
            >
              <Icon size={15} />
              <span className="hidden md:inline">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}